export enum PeriodYear {
  Year1,
  Year2,
}
